import { SEARCH_RESULTS_REQUEST, SEARCH_RESULTS_SUCCESS, SEARCH_RESULTS_FAIL } from '../actions/searchActions';

const initialState = {
  loading: false,
  error: null,
  searchResults: [],
};

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_RESULTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SEARCH_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: state.searchResults.concat(action.payload), // Append new data
      };
    case SEARCH_RESULTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
